var map = {
	"./": 7672,
	"./App": 3465,
	"./App.tsx": 3465,
	"./animations": 6680,
	"./animations/": 6680,
	"./animations/index": 6680,
	"./animations/index.tsx": 6680,
	"./apiRoutes": 8157,
	"./apiRoutes/": 8157,
	"./apiRoutes/index": 8157,
	"./apiRoutes/index.ts": 8157,
	"./assets/adventCalendar/background.png": 3093,
	"./assets/ajinomotoLogo.png": 1013,
	"./assets/ajinomotoWheel/background.png": 2956,
	"./assets/ajinomotoWheel/backgroundMobile.png": 4587,
	"./assets/ajinomotoWheel/gameName.png": 8829,
	"./assets/ajinomotoWheel/gameNameMobile.png": 3587,
	"./assets/ajinomotoWheel/pointeur.png": 3266,
	"./assets/ajinomotoWheel/wheel.png": 7410,
	"./assets/bmiValentinesDayLogo.png": 2426,
	"./assets/bmiValentinesDayWheel/background.png": 9994,
	"./assets/bmiValentinesDayWheel/backgroundMobile.png": 4354,
	"./assets/bmiValentinesDayWheel/gameName.png": 2829,
	"./assets/bmiValentinesDayWheel/gameNameMobile.png": 257,
	"./assets/bmiValentinesDayWheel/pointeur.png": 3706,
	"./assets/bmiValentinesDayWheel/wheel.png": 2280,
	"./assets/christmasFortuneWheel/background.png": 4153,
	"./assets/christmasFortuneWheel/gameName.png": 6203,
	"./assets/christmasFortuneWheel/pointeur.png": 1705,
	"./assets/christmasFortuneWheel/presents.png": 6239,
	"./assets/christmasFortuneWheel/wheel.png": 5357,
	"./assets/classicWheel/background.png": 6650,
	"./assets/classicWheel/gameName.png": 1046,
	"./assets/classicWheel/gameNameMobile.png": 1574,
	"./assets/classicWheel/pointeur.png": 7033,
	"./assets/classicWheel/wheel.png": 7902,
	"./assets/common/mainLogo.png": 4130,
	"./assets/estivalWheel/background.png": 9332,
	"./assets/estivalWheel/gameName.png": 3268,
	"./assets/estivalWheel/gameNameMobile.png": 2694,
	"./assets/estivalWheel/pointeur.png": 5073,
	"./assets/estivalWheel/wheel.png": 9008,
	"./assets/grippleLogo.png": 9798,
	"./assets/grippleWheel/background.png": 2143,
	"./assets/grippleWheel/backgroundMobile.png": 6618,
	"./assets/grippleWheel/gameName.png": 7315,
	"./assets/grippleWheel/gameNameMobile.png": 8590,
	"./assets/grippleWheel/pointeur.png": 7119,
	"./assets/grippleWheel/wheel.png": 3928,
	"./assets/logo-exemple.png": 6969,
	"./assets/losteLogo.png": 8100,
	"./assets/losteWheel/background.png": 3473,
	"./assets/losteWheel/backgroundMobile.png": 4203,
	"./assets/losteWheel/gameName.png": 754,
	"./assets/losteWheel/gameNameMobile.png": 7473,
	"./assets/losteWheel/pointeur.png": 7920,
	"./assets/losteWheel/wheel.png": 9393,
	"./assets/sirhaWheel/background.png": 7181,
	"./assets/sirhaWheel/backgroundMobile.png": 9760,
	"./assets/sirhaWheel/gameName.png": 2996,
	"./assets/sirhaWheel/gameNameMobile.png": 1590,
	"./assets/sirhaWheel/pointeur.png": 1057,
	"./assets/sirhaWheel/wheel.png": 1940,
	"./assets/stickAndPlayLogo.png": 8897,
	"./assets/stickAndPlayWheel/background.png": 4725,
	"./assets/stickAndPlayWheel/backgroundMobile.png": 1241,
	"./assets/stickAndPlayWheel/gameName.png": 8330,
	"./assets/stickAndPlayWheel/gameNameMobile.png": 6430,
	"./assets/stickAndPlayWheel/pointeur.png": 6123,
	"./assets/stickAndPlayWheel/wheel.png": 4760,
	"./assets/wheel.png": 7972,
	"./components/AlertToDisplay": 7827,
	"./components/AlertToDisplay/": 7827,
	"./components/AlertToDisplay/index": 7827,
	"./components/AlertToDisplay/index.tsx": 7827,
	"./components/NoGameAvailable": 3991,
	"./components/NoGameAvailable/": 3991,
	"./components/NoGameAvailable/index": 3991,
	"./components/NoGameAvailable/index.tsx": 3991,
	"./components/NoGameAvailable/style": 5541,
	"./components/NoGameAvailable/style.ts": 5541,
	"./components/common/Alert": 7431,
	"./components/common/Alert/": 7431,
	"./components/common/Alert/index": 7431,
	"./components/common/Alert/index.tsx": 7431,
	"./components/common/Alert/style": 2289,
	"./components/common/Alert/style.ts": 2289,
	"./components/common/Card": 435,
	"./components/common/Card/": 435,
	"./components/common/Card/index": 435,
	"./components/common/Card/index.tsx": 435,
	"./components/common/Card/style": 6086,
	"./components/common/Card/style.ts": 6086,
	"./components/common/Loader": 4597,
	"./components/common/Loader/": 4597,
	"./components/common/Loader/index": 4597,
	"./components/common/Loader/index.tsx": 4597,
	"./components/games": 5140,
	"./components/games/": 5140,
	"./components/games/AdventCalendarGame": 7570,
	"./components/games/AdventCalendarGame/": 7570,
	"./components/games/AdventCalendarGame/Backdrop": 7992,
	"./components/games/AdventCalendarGame/Backdrop/": 7992,
	"./components/games/AdventCalendarGame/Backdrop/index": 7992,
	"./components/games/AdventCalendarGame/Backdrop/index.tsx": 7992,
	"./components/games/AdventCalendarGame/Backdrop/style": 4473,
	"./components/games/AdventCalendarGame/Backdrop/style.ts": 4473,
	"./components/games/AdventCalendarGame/CalendarContainer": 668,
	"./components/games/AdventCalendarGame/CalendarContainer/": 668,
	"./components/games/AdventCalendarGame/CalendarContainer/index": 668,
	"./components/games/AdventCalendarGame/CalendarContainer/index.tsx": 668,
	"./components/games/AdventCalendarGame/CalendarContainer/style": 6313,
	"./components/games/AdventCalendarGame/CalendarContainer/style.ts": 6313,
	"./components/games/AdventCalendarGame/Day": 9344,
	"./components/games/AdventCalendarGame/Day/": 9344,
	"./components/games/AdventCalendarGame/Day/index": 9344,
	"./components/games/AdventCalendarGame/Day/index.tsx": 9344,
	"./components/games/AdventCalendarGame/Day/style": 9488,
	"./components/games/AdventCalendarGame/Day/style.ts": 9488,
	"./components/games/AdventCalendarGame/Footer": 8286,
	"./components/games/AdventCalendarGame/Footer/": 8286,
	"./components/games/AdventCalendarGame/Footer/index": 8286,
	"./components/games/AdventCalendarGame/Footer/index.tsx": 8286,
	"./components/games/AdventCalendarGame/Footer/style": 3681,
	"./components/games/AdventCalendarGame/Footer/style.ts": 3681,
	"./components/games/AdventCalendarGame/InformationContainer": 2284,
	"./components/games/AdventCalendarGame/InformationContainer/": 2284,
	"./components/games/AdventCalendarGame/InformationContainer/index": 2284,
	"./components/games/AdventCalendarGame/InformationContainer/index.tsx": 2284,
	"./components/games/AdventCalendarGame/InformationContainer/style": 6012,
	"./components/games/AdventCalendarGame/InformationContainer/style.ts": 6012,
	"./components/games/AdventCalendarGame/LoserResult": 1400,
	"./components/games/AdventCalendarGame/LoserResult/": 1400,
	"./components/games/AdventCalendarGame/LoserResult/index": 1400,
	"./components/games/AdventCalendarGame/LoserResult/index.tsx": 1400,
	"./components/games/AdventCalendarGame/LoserResult/styles": 649,
	"./components/games/AdventCalendarGame/LoserResult/styles.ts": 649,
	"./components/games/AdventCalendarGame/MobileView": 7039,
	"./components/games/AdventCalendarGame/MobileView/": 7039,
	"./components/games/AdventCalendarGame/MobileView/index": 7039,
	"./components/games/AdventCalendarGame/MobileView/index.tsx": 7039,
	"./components/games/AdventCalendarGame/MobileView/style": 7199,
	"./components/games/AdventCalendarGame/MobileView/style.ts": 7199,
	"./components/games/AdventCalendarGame/WinnerResult": 8302,
	"./components/games/AdventCalendarGame/WinnerResult/": 8302,
	"./components/games/AdventCalendarGame/WinnerResult/index": 8302,
	"./components/games/AdventCalendarGame/WinnerResult/index.tsx": 8302,
	"./components/games/AdventCalendarGame/WinnerResult/style": 520,
	"./components/games/AdventCalendarGame/WinnerResult/style.ts": 520,
	"./components/games/AdventCalendarGame/index": 7570,
	"./components/games/AdventCalendarGame/index.tsx": 7570,
	"./components/games/AdventCalendarGame/style": 7731,
	"./components/games/AdventCalendarGame/style.ts": 7731,
	"./components/games/AdventCalendarRawGame": 6027,
	"./components/games/AdventCalendarRawGame/": 6027,
	"./components/games/AdventCalendarRawGame/Backdrop": 6755,
	"./components/games/AdventCalendarRawGame/Backdrop/": 6755,
	"./components/games/AdventCalendarRawGame/Backdrop/index": 6755,
	"./components/games/AdventCalendarRawGame/Backdrop/index.tsx": 6755,
	"./components/games/AdventCalendarRawGame/Backdrop/style": 8226,
	"./components/games/AdventCalendarRawGame/Backdrop/style.ts": 8226,
	"./components/games/AdventCalendarRawGame/CalendarContainer": 2815,
	"./components/games/AdventCalendarRawGame/CalendarContainer/": 2815,
	"./components/games/AdventCalendarRawGame/CalendarContainer/index": 2815,
	"./components/games/AdventCalendarRawGame/CalendarContainer/index.tsx": 2815,
	"./components/games/AdventCalendarRawGame/CalendarContainer/style": 9876,
	"./components/games/AdventCalendarRawGame/CalendarContainer/style.ts": 9876,
	"./components/games/AdventCalendarRawGame/Day": 6099,
	"./components/games/AdventCalendarRawGame/Day/": 6099,
	"./components/games/AdventCalendarRawGame/Day/BaubleIcon": 8531,
	"./components/games/AdventCalendarRawGame/Day/BaubleIcon.tsx": 8531,
	"./components/games/AdventCalendarRawGame/Day/index": 6099,
	"./components/games/AdventCalendarRawGame/Day/index.tsx": 6099,
	"./components/games/AdventCalendarRawGame/Day/style": 4383,
	"./components/games/AdventCalendarRawGame/Day/style.ts": 4383,
	"./components/games/AdventCalendarRawGame/LoserResult": 3378,
	"./components/games/AdventCalendarRawGame/LoserResult/": 3378,
	"./components/games/AdventCalendarRawGame/LoserResult/index": 3378,
	"./components/games/AdventCalendarRawGame/LoserResult/index.tsx": 3378,
	"./components/games/AdventCalendarRawGame/LoserResult/styles": 2813,
	"./components/games/AdventCalendarRawGame/LoserResult/styles.ts": 2813,
	"./components/games/AdventCalendarRawGame/MobileView": 4398,
	"./components/games/AdventCalendarRawGame/MobileView/": 4398,
	"./components/games/AdventCalendarRawGame/MobileView/index": 4398,
	"./components/games/AdventCalendarRawGame/MobileView/index.tsx": 4398,
	"./components/games/AdventCalendarRawGame/MobileView/style": 3429,
	"./components/games/AdventCalendarRawGame/MobileView/style.ts": 3429,
	"./components/games/AdventCalendarRawGame/WinnerResult": 2312,
	"./components/games/AdventCalendarRawGame/WinnerResult/": 2312,
	"./components/games/AdventCalendarRawGame/WinnerResult/index": 2312,
	"./components/games/AdventCalendarRawGame/WinnerResult/index.tsx": 2312,
	"./components/games/AdventCalendarRawGame/WinnerResult/style": 3005,
	"./components/games/AdventCalendarRawGame/WinnerResult/style.ts": 3005,
	"./components/games/AdventCalendarRawGame/index": 6027,
	"./components/games/AdventCalendarRawGame/index.tsx": 6027,
	"./components/games/AdventCalendarRawGame/style": 4277,
	"./components/games/AdventCalendarRawGame/style.ts": 4277,
	"./components/games/ChristmasFortuneWheelGame": 4252,
	"./components/games/ChristmasFortuneWheelGame/": 4252,
	"./components/games/ChristmasFortuneWheelGame/ClickHereCircle": 6523,
	"./components/games/ChristmasFortuneWheelGame/ClickHereCircle/": 6523,
	"./components/games/ChristmasFortuneWheelGame/ClickHereCircle/index": 6523,
	"./components/games/ChristmasFortuneWheelGame/ClickHereCircle/index.tsx": 6523,
	"./components/games/ChristmasFortuneWheelGame/ClickHereCircle/style": 5076,
	"./components/games/ChristmasFortuneWheelGame/ClickHereCircle/style.ts": 5076,
	"./components/games/ChristmasFortuneWheelGame/DescriptionCard": 2916,
	"./components/games/ChristmasFortuneWheelGame/DescriptionCard/": 2916,
	"./components/games/ChristmasFortuneWheelGame/DescriptionCard/index": 2916,
	"./components/games/ChristmasFortuneWheelGame/DescriptionCard/index.tsx": 2916,
	"./components/games/ChristmasFortuneWheelGame/DescriptionCard/sytle": 3008,
	"./components/games/ChristmasFortuneWheelGame/DescriptionCard/sytle.ts": 3008,
	"./components/games/ChristmasFortuneWheelGame/Footer": 1347,
	"./components/games/ChristmasFortuneWheelGame/Footer/": 1347,
	"./components/games/ChristmasFortuneWheelGame/Footer/index": 1347,
	"./components/games/ChristmasFortuneWheelGame/Footer/index.tsx": 1347,
	"./components/games/ChristmasFortuneWheelGame/Footer/style": 3726,
	"./components/games/ChristmasFortuneWheelGame/Footer/style.ts": 3726,
	"./components/games/ChristmasFortuneWheelGame/LogoCard": 3408,
	"./components/games/ChristmasFortuneWheelGame/LogoCard/": 3408,
	"./components/games/ChristmasFortuneWheelGame/LogoCard/index": 3408,
	"./components/games/ChristmasFortuneWheelGame/LogoCard/index.tsx": 3408,
	"./components/games/ChristmasFortuneWheelGame/LogoCard/style": 6586,
	"./components/games/ChristmasFortuneWheelGame/LogoCard/style.ts": 6586,
	"./components/games/ChristmasFortuneWheelGame/LoserCard": 5165,
	"./components/games/ChristmasFortuneWheelGame/LoserCard/": 5165,
	"./components/games/ChristmasFortuneWheelGame/LoserCard/index": 5165,
	"./components/games/ChristmasFortuneWheelGame/LoserCard/index.tsx": 5165,
	"./components/games/ChristmasFortuneWheelGame/WinnerCard": 6792,
	"./components/games/ChristmasFortuneWheelGame/WinnerCard/": 6792,
	"./components/games/ChristmasFortuneWheelGame/WinnerCard/index": 6792,
	"./components/games/ChristmasFortuneWheelGame/WinnerCard/index.tsx": 6792,
	"./components/games/ChristmasFortuneWheelGame/WinnerCard/sytle": 2013,
	"./components/games/ChristmasFortuneWheelGame/WinnerCard/sytle.ts": 2013,
	"./components/games/ChristmasFortuneWheelGame/index": 4252,
	"./components/games/ChristmasFortuneWheelGame/index.tsx": 4252,
	"./components/games/ChristmasFortuneWheelGame/style": 5363,
	"./components/games/ChristmasFortuneWheelGame/style.ts": 5363,
	"./components/games/ClassicWheelGame": 7342,
	"./components/games/ClassicWheelGame/": 7342,
	"./components/games/ClassicWheelGame/ClickHereCircle": 7017,
	"./components/games/ClassicWheelGame/ClickHereCircle/": 7017,
	"./components/games/ClassicWheelGame/ClickHereCircle/index": 7017,
	"./components/games/ClassicWheelGame/ClickHereCircle/index.tsx": 7017,
	"./components/games/ClassicWheelGame/ClickHereCircle/style": 1018,
	"./components/games/ClassicWheelGame/ClickHereCircle/style.ts": 1018,
	"./components/games/ClassicWheelGame/DescriptionCard": 3252,
	"./components/games/ClassicWheelGame/DescriptionCard/": 3252,
	"./components/games/ClassicWheelGame/DescriptionCard/index": 3252,
	"./components/games/ClassicWheelGame/DescriptionCard/index.tsx": 3252,
	"./components/games/ClassicWheelGame/DescriptionCard/sytle": 7165,
	"./components/games/ClassicWheelGame/DescriptionCard/sytle.ts": 7165,
	"./components/games/ClassicWheelGame/Footer": 2756,
	"./components/games/ClassicWheelGame/Footer/": 2756,
	"./components/games/ClassicWheelGame/Footer/index": 2756,
	"./components/games/ClassicWheelGame/Footer/index.tsx": 2756,
	"./components/games/ClassicWheelGame/Footer/style": 6127,
	"./components/games/ClassicWheelGame/Footer/style.ts": 6127,
	"./components/games/ClassicWheelGame/LogoCard": 3630,
	"./components/games/ClassicWheelGame/LogoCard/": 3630,
	"./components/games/ClassicWheelGame/LogoCard/index": 3630,
	"./components/games/ClassicWheelGame/LogoCard/index.tsx": 3630,
	"./components/games/ClassicWheelGame/LogoCard/style": 8756,
	"./components/games/ClassicWheelGame/LogoCard/style.ts": 8756,
	"./components/games/ClassicWheelGame/LoserCard": 7071,
	"./components/games/ClassicWheelGame/LoserCard/": 7071,
	"./components/games/ClassicWheelGame/LoserCard/index": 7071,
	"./components/games/ClassicWheelGame/LoserCard/index.tsx": 7071,
	"./components/games/ClassicWheelGame/WinnerCard": 5662,
	"./components/games/ClassicWheelGame/WinnerCard/": 5662,
	"./components/games/ClassicWheelGame/WinnerCard/index": 5662,
	"./components/games/ClassicWheelGame/WinnerCard/index.tsx": 5662,
	"./components/games/ClassicWheelGame/WinnerCard/sytle": 2194,
	"./components/games/ClassicWheelGame/WinnerCard/sytle.ts": 2194,
	"./components/games/ClassicWheelGame/index": 7342,
	"./components/games/ClassicWheelGame/index.tsx": 7342,
	"./components/games/ClassicWheelGame/style": 5019,
	"./components/games/ClassicWheelGame/style.ts": 5019,
	"./components/games/index": 5140,
	"./components/games/index.tsx": 5140,
	"./helpers": 1474,
	"./helpers.ts": 1474,
	"./hooks": 1780,
	"./hooks/": 1780,
	"./hooks/index": 1780,
	"./hooks/index.tsx": 1780,
	"./index": 7672,
	"./index.css": 1174,
	"./index.tsx": 7672,
	"./mocks": 3843,
	"./mocks.ts": 3843,
	"./translations": 745,
	"./translations/": 745,
	"./translations/index": 745,
	"./translations/index.tsx": 745,
	"./translations/languages/dutchTranslations": 1632,
	"./translations/languages/dutchTranslations.json": 1632,
	"./translations/languages/englishTranslations": 3076,
	"./translations/languages/englishTranslations.json": 3076,
	"./translations/languages/frenchTranslations": 5304,
	"./translations/languages/frenchTranslations.json": 5304,
	"./translations/languages/germanTranslations": 366,
	"./translations/languages/germanTranslations.json": 366,
	"./translations/languages/spanishTranslations": 3731,
	"./translations/languages/spanishTranslations.json": 3731,
	"./types": 3944,
	"./types/": 3944,
	"./types/images.d": 4179,
	"./types/images.d.ts": 4179,
	"./types/index": 3944,
	"./types/index.ts": 3944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;